import { Button, Table } from "antd";
import { useEffect, useState } from "react";
import AutoDriverDetails from "../BuisnessPdDetails/AutoDriverDetails";
import DairyDetails from "../BuisnessPdDetails/DairyDetails";
import AutoGarageDetails from "../BuisnessPdDetails/AutoGarageDetails";
import ContractorDetails from "../BuisnessPdDetails/ContractorDetails";
import CableOperatorDetails from "../BuisnessPdDetails/CableOperatorDetails";
import CateringBuisnessDetails from "../BuisnessPdDetails/CateringBuisnessDetails";
import GarmentsDetails from "../BuisnessPdDetails/GarmentsDetails";
import FlourMillDetails from "../BuisnessPdDetails/FlourMillDetails";
import GroceryDetail from "../BuisnessPdDetails/GroceryDetail";
import SaloonDetail from "../BuisnessPdDetails/SaloonDetail";
import SweetShopDetail from "../BuisnessPdDetails/SweetShopDetail";
import JuiceCenterDetail from "../BuisnessPdDetails/JuiceCenterDetail"
import TeaStallDetails from "../BuisnessPdDetails/TeaStallDetails";
import TailorDetail from "../BuisnessPdDetails/TailorDetail";
import NoDataFound from "../NoDataFound";
import TentHouseDetails from "../BuisnessPdDetails/TentHouseDetails";
import Vegetabledetail from "../BuisnessPdDetails/Vegetabledetail"

const ShopTable = ({ allData = [] }) => { // Default to empty array if undefined
    console.log(allData)
  const [showAll, setShowAll] = useState(false); // State to manage view mode

  const state= allData?.state
  const data = allData?.state?.incomes

  return (

    <>
    
    <div className="col-md-12 d-flex">
      <div className="card card-table flex-fill">
        <div className="card-header">
        </div>
        <div className="card-body">
          <div className="table-responsive">
          {state?.profileId == "1" ? (
                  <AutoDriverDetails allData={data} />
                ) : state?.profileId == "20" ? (
                  <DairyDetails allData={data} />
                ) : state?.profileId == "2" ? (
                  <AutoGarageDetails allData={data} />
                ) : state?.profileId == "6" ? (
                  <ContractorDetails allData={data} />
                ) : state?.profileId == "4" ? (
                  <CableOperatorDetails allData={data} />
                ) : state?.profileId == "5" ? (
                  <CateringBuisnessDetails allData={data} />
                ) : state?.profileId == "8" ? (
                  <GarmentsDetails allData={data} />
                ) : state?.profileId == "7" ? (
                  <FlourMillDetails allData={data} />
                ) : state?.profileId == "10" ? (
                  <JuiceCenterDetail allData={data} />
                ) : state?.profileId == "11" ? (
                  <GroceryDetail allData={data} />
                ) : state?.profileId == "13" ? (
                  <SaloonDetail allData={data} />
                ) : state?.profileId == "15" ? (
                  <SweetShopDetail allData={data} />
                ) : state?.profileId == "17" ? (
                  <TeaStallDetails allData={data} />
                ) : state?.profileId == "18" ? (
                  <TentHouseDetails allData={data} />
                ) : state?.profileId == "19" ? (
                  <Vegetabledetail allData={data} />
                ) : state?.profileId == "16" ? (
                  <TailorDetail allData={data} />
                ) : (
                  <NoDataFound />
                )}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ShopTable;
